/**
 * Shared React Query keys for expert-review.
 *
 * Belongs here: query-key constants only.
 * Does not belong here: fetchers or hooks.
 */
export const QUESTIONNAIRE_STATUS_QUERY_KEY = ['allocation-questionnaire-status'] as const
export const STRATEGY_QUESTIONNAIRE_QUERY_KEY = ['allocation-strategy-questionnaire'] as const
export const PREFERENCES_QUESTIONNAIRE_QUERY_KEY = ['allocation-preferences-questionnaire'] as const
